// extracted by mini-css-extract-plugin
export default {"sib-logo":"QMFYvCXYOjwEiqco9nOq","sib-logo__clickable":"DuwxVkk91IsI7aDYnViR","sib--svg":"tXkC_q5hoeeIkt93UQ1D"};